import React, { forwardRef } from 'react';
import { Col, Row } from 'react-bootstrap';
import { getFullNameUser, numberWithCommas } from '../../Helpers/Utils/Common';

const PrintCategory = forwardRef(( props, ref ) => {
  return (
  <div ref={ref} className='p-2'>
    <Row>
        <Col>
            <Row>
                <Col>
                    <label className='print-text-category'>{window.company_name}</label>
                </Col>
                <Col className='d-flex justify-content-end print-text-category'>
                    {/* {getFullNameUser()} */}
                </Col>
            </Row>
            {/* <Row>
                <label className='print-text-category'>Trade Name</label>
            </Row> */}
            <Row>
                <label className='print-text-category'>{window.company_address1} {window.company_address2}</label>
            </Row>
             <Row>
                <label className='print-text-category'>DATE FROM: {props.filter.date_from}</label>
            </Row>
             <Row>
                <label className='print-text-category'>DATE TO: {props.filter.date_to}</label>
            </Row>
            <Row>
                <label className='print-text-category'>CASHIER: {getFullNameUser()}</label>
            </Row>
        </Col>
    </Row>
    <Row>
        {/* to be condition if button clicked is hourly print hourly else daily*/}
        {props.tab === "hourly" ?
            <Col className='d-flex justify-content-center'>
                <strong>Hourly Sales Report</strong>
            </Col>
        :
            <Col>
                {/* <Row>
                    <Col className='d-flex justify-content-center print-text-category'>
                        <strong>Daily</strong>
                    </Col>
                </Row> */}
                <Row className='pt-1'>
                    <Col className='d-flex justify-content-center print-text-category'>
                        <strong>DAILY MENU ITEM SALES REPORT</strong>
                    </Col>
                </Row>
                {/* <Row>
                    <Col className='d-flex justify-content-center print-text-category'>
                        <strong>Report</strong>
                    </Col>
                </Row> */}
            </Col>
        }
        <hr/>
    </Row>
    {/* to be condition if hourly sales print this */}
    {props.tab === "hourly" ?
    <>
    <Row>
        <Col>
            <Row>
                <Col>
                    <label>Time</label>
                </Col>
            </Row>
            <Row>
                <Col>
                    <label>1:00 - 2:00</label>
                </Col>
            </Row>
        </Col>
        <Col>
            <Row>
                <Col>
                    <label>Total Sales</label>
                </Col>
            </Row>
            <Row>
                <Col>
                    <label>P 30000</label>
                </Col>
            </Row>
        </Col>
    </Row>
    <Row>
        <Col>
            <label>Total:</label>
            <label>30000</label>
        </Col>
    </Row>
    </>
    :
    <>
     {/* to be condition if daily sales print this */}
     {/* <Row>
        <Col>
            <label className='print-text-category'>Item/s</label>
        </Col>
        <Col className='d-flex justify-content-center print-text-category'>
            <label>QTY</label>
        </Col>
        <Col className='d-flex justify-content-end print-text-category'>
            <label>Total Sales</label>
        </Col>
     </Row>
        {props.data2.map((data) => {
            return (
                data.items && data.items.map((item) => (
                    <Row key={item.menu_name}>
                        <Col className='print-text-category'>{item.menu_name}</Col>
                        <Col className='d-flex justify-content-center print-text-category'>{item.total_qty}</Col>
                        <Col className='d-flex justify-content-end print-text-category'>{numberWithCommas(item.total_amount)}</Col>
                    </Row>
                ))
            );
        })} */}
        {props.data2.map((data) => {
            return (
                <Row key={data.name} className='pt-1 '>
                    {data.items && data.items.length > 0 &&
                    <>
                    <Col xl={5} className='print-text-category'>
                        <strong>{data.name.toUpperCase()}</strong>
                    </Col>
                    <Col xl={1} className='d-flex justify-content-center print-text-category'>QTY</Col>
                    <Col xl={6} className='d-flex justify-content-end print-text-category'>
                        TOTAL SALES : {numberWithCommas(data.items && data.items.length > 0 ? data.items.map((item) => parseFloat(item.total_amount)).reduce((a, b) => a + b, 0).toFixed(2) : "0.00")}
                    </Col>
                    {data.items && data.items.map((item) => (
                        <Row key={item.menu_name} className='ms-1 pt-1'>
                            <Col xl={5} className='print-text-category'>{item.menu_name}</Col>
                            <Col xl={1} className='d-flex justify-content-center print-text-category'>{item.total_qty}</Col>
                            <Col xl={6} className='d-flex justify-content-end print-text-category'>{numberWithCommas(item.total_amount)}</Col>
                        </Row>
                    ))}
                    </>
                }
                </Row>
            );
        })}
    <Row className='pt-3'>
        <Col>
            <label className='print-text-category'><strong>Subtotal:</strong></label>
        </Col>
        <Col className='d-flex justify-content-center print-text-category'>
            {/* <label><strong>{props.data && props.data.length > 0 ? props.data.map((item) => parseInt(item.total_qty)).reduce((a, b) => a + b, 0) : "0.00"}</strong></label> */}
        </Col>
        <Col className='d-flex justify-content-end print-text-category'>
            <label><strong>{props.totals.subtotal}</strong></label>
            {/* Total Sales : {numberWithCommas(props.data && props.data.length > 0 ? props.data.map((item) => parseFloat(item.total_amount)).reduce((a, b) => a + b, 0).toFixed(2) : "0.00")} */}
            {/* <label><strong>{numberWithCommas(props.data && props.data.length > 0 ? props.data.map((item) => parseFloat(item.total_amount)).reduce((a, b) => a + b, 0).toFixed(2) : "0.00")}</strong></label> */}
        </Col>
     </Row>
     <Row>
        <Col>
            <label className='print-text-category'><strong>B1T1 Discount:</strong></label>
        </Col>
        <Col className='d-flex justify-content-center print-text-category'>
            {/* <label><strong>{props.data && props.data.length > 0 ? props.data.map((item) => parseInt(item.total_qty)).reduce((a, b) => a + b, 0) : "0.00"}</strong></label> */}
        </Col>
        <Col className='d-flex justify-content-end print-text-category'>
            <label><strong>{props.totals.less_discount}</strong></label>
            {/* Total Sales : {numberWithCommas(props.data && props.data.length > 0 ? props.data.map((item) => parseFloat(item.total_amount)).reduce((a, b) => a + b, 0).toFixed(2) : "0.00")} */}
            {/* <label><strong>{numberWithCommas(props.data && props.data.length > 0 ? props.data.map((item) => parseFloat(item.total_amount)).reduce((a, b) => a + b, 0).toFixed(2) : "0.00")}</strong></label> */}
        </Col>
     </Row>
     <Row>
        <Col>
            <label className='print-text-category'><strong>Grand Total:</strong></label>
        </Col>
        <Col className='d-flex justify-content-center print-text-category'>
            {/* <label><strong>{props.data && props.data.length > 0 ? props.data.map((item) => parseInt(item.total_qty)).reduce((a, b) => a + b, 0) : "0.00"}</strong></label> */}
        </Col>
        <Col className='d-flex justify-content-end print-text-category'>
            <label><strong>{props.totals.grand_total}</strong></label>
            {/* Total Sales : {numberWithCommas(props.data && props.data.length > 0 ? props.data.map((item) => parseFloat(item.total_amount)).reduce((a, b) => a + b, 0).toFixed(2) : "0.00")} */}
            {/* <label><strong>{numberWithCommas(props.data && props.data.length > 0 ? props.data.map((item) => parseFloat(item.total_amount)).reduce((a, b) => a + b, 0).toFixed(2) : "0.00")}</strong></label> */}
        </Col>
     </Row>
    </>
    }
  </div>
)});

export default PrintCategory;